import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Hidden from '@material-ui/core/Hidden';
// import '../common.css';
import "./review.css"

const useStyles = makeStyles({
  card: {
    display: 'flex',
  },
  cardDetails: {
    flex: 1,
  },
  cardMedia: {
    width: 160,
  },
  NavSize:{
    
    paddingBottom: "40px",
    paddingLeft: "26px",
  }
});

export default function FeaturedPost(props) {
  const classes = useStyles();
  const { post } = props;

  return (
    <Fragment>


<div class="testimonial">
<section class="section-ptb bg-white bg-5">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="client-testimonial position-relative">
            <div class={`client-nav ${classes.NavSize}`} >
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a class="nav-link active" href="#client1" data-toggle="tab">
                    <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/1.png" alt="Client Image" />
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#client2" data-toggle="tab">
                    <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/2.png" alt="Client Image" />
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#client3" data-toggle="tab">
                    <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/3.png" alt="Client Image" />
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#client4" data-toggle="tab">
                    <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/4.png" alt="Client Image" />
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#client5" data-toggle="tab">
                    <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/5.png" alt="Client Image" />
                  </a>
                </li>
              </ul>
            </div>
            <div class="row text-center">
              <div class="col-10 col-md-8 col-lg-6 mx-auto">
                <div class="tab-content">
                  <div class="tab-pane fade show active" id="client1">
                    <div class="client-thumb mx-auto mb-25">
                      <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/1.png" alt="Client Image" />
                    </div>
                    <div class="client-desc bg-white d-flex align-items-center">
                      <div class="text mx-auto">
                        <h4 class="mb-10">Evelyn Riley</h4>
                        <h6>My best Experience</h6>
                        <p>OBLU by Atmosphere – A slumbering paradise for nature lovers! <br class="d-none d-lg-block"/>While some 
                        might argue that travelling is as much about the destination,</p>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="client2">
                    <div class="client-thumb mx-auto mb-25">
                      <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/2.png" alt="Client Image" />
                    </div>
                    <div class="client-desc bg-white d-flex align-items-center">
                      <div class="text mx-auto">
                        <h4 class="mb-10">Ethan Green</h4>
                        <h6>It was a Day Dream</h6>
                        <p> Heaven on Earth was my Dream Destination to Go. Happened <br class="d-none d-lg-block" /> was Most 
                        Memorable one. Thanks to FLYNOTE for Best Experts they Appointed,</p>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="client3">
                    <div class="client-thumb mx-auto mb-25">
                      <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/3.png" alt="Client Image" />
                    </div>
                    <div class="client-desc bg-white d-flex align-items-center">
                      <div class="text mx-auto">
                        <h4 class="mb-10">Marie Soto</h4>
                        <h6>Best Experience</h6>
                        <p>Virginia, looked up one of the more obscure Latin <br class="d-none d-lg-block" /> words, consectetur, from a Lorem Ipsum passage, and going through the cites of looked</p>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="client4">
                    <div class="client-thumb mx-auto mb-25">
                      <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/4.png" alt="Client Image" />
                    </div>
                    <div class="client-desc bg-white d-flex align-items-center">
                      <div class="text mx-auto">
                        <h4 class="mb-10">Willie Munoz</h4>
                        <h6>Content Writer</h6>
                        <p>Words which don't look even slightly believable. <br class="d-none d-lg-block" />If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything</p>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="client5">
                    <div class="client-thumb mx-auto mb-25">
                      <img class="drop-shadow" src="http://regaltheme.com/tf/multi/rnr/assets/img/client/thumb/5.png" alt="Client Image" />
                    </div>
                    <div class="client-desc bg-white d-flex align-items-center">
                      <div class="text mx-auto">
                        <h4 class="mb-10">Susan Gardner</h4>
                        <h6>Manager</h6>
                        <p>The point of using Lorem Ipsum is that it has a more <br class="d-none d-lg-block" /> normal distribution of letters, as opposed to using 'Content here, content here point of using</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

    </Fragment>
    
  );
}

// FeaturedPost.propTypes = {
//   post: PropTypes.object,
// };














// <Grid item xs={12} md={4} spacing={4}>
  
//   <div className="holder mb-5">   
  
  {/* <!-- Box 2 below --> */}
  {/* <div className="space">
      <div className="imgBox">
          <img src={post.image} alt="features"  style={{borderRadius:"25px"}} />
      </div>
      <div className="contentBox">
          <h3>
              {post.title}
          </h3>
          <span>{post.date}</span>
          <p>
             <span>{post.description}</span>
              </p> */}
              {/* <button className="buyBtn" type="submit">Get Now</button> */}
      {/* </div>
  </div>
  </div>
      </Grid> */}